<script setup lang="ts">
import { useTranslation } from "i18next-vue";
import { computed, ref } from "vue";

const { t } = useTranslation();

import { storeToRefs } from "pinia";
import OrderCompleted from "../../assets/iconsDynamic/OrderCompleted.vue";
import { useOrderStore } from "../../store/modules/order/order";

import ButtonDefault from "../../ui/buttons/default/ButtonDefault.vue";

const orderStore = useOrderStore();
const { ordersReady } = storeToRefs(orderStore);

const closeModal = () => {
	ordersReady.value = [];
};

const isVisible = computed(() => ordersReady.value.length > 0);
</script>

<template>
	<div v-if="isVisible" class="order_completed_overlay">
		<main class="order_completed_wrapper">
			<div class="order_completed_info">
				<div class="order_completed_icon">
					<OrderCompleted />
				</div>
				<div class="order_completed_text" v-for="order in ordersReady">
					<p class="order_table_number">{{ t(`order-completed.table-number`) }} № {{ order.table_number }}</p>
					<p>{{ t(`order-completed.order-number`) }} {{ order.order_number }} {{ t(`order-completed.is-ready`) }}</p>
				</div>
				<div class="order_completed_button">
					<ButtonDefault
						:textButtonDefault="t(`order-completed.button.ok`)"
						:onClick="() => closeModal()"
						:style="{
							padding: '15px 0px',
							width: '60%'
						}"
					/>
				</div>
			</div>
		</main>
	</div>
</template>

<style lang="scss">
  @use './orderCompleted.scss';
</style>
